<template>
  <!-- @touchmove.prevent -->
  <div
    :class="{
      BoxContent: true,
      BoxMore: detail.share_list.length > 1,
    }"
    ref="scrollContainer"
  >
    <div class="boxOne">
      <img :src="detail.logo" class="leftLogo" />
      <div class="rightBox">
        <div class="one">
          <span class="font1">{{ detail.username }}&nbsp;分享的链接</span>
          <svg-btn
            @click="checkCollect"
            :icon-class="
              detail.is_collect == 1 ? 'icon-collect-two' : 'icon-collect-one'
            "
            class="collect"
          ></svg-btn>
        </div>
        <div class="topBox">
          <div class="two">
            <span class="font2"
              >该链接由{{ detail.username }}自行分享，并不代表本站立场</span
            >
          </div>
          <span class="font3" @click="checkReport">举报</span>
        </div>
      </div>
      <!-- <div class="one">
        <img :src="detail.web_icon" class="leftLogo" />
        <div class="rightBox">
          <span class="font1">{{ detail.url_title }}</span>
        </div>
      </div>
      <div class="topBox">
        <div class="two">
          <span class="font2"
            >该链接由{{ detail.username }}自行分享，并不代表本站立场</span
          >
        </div>
        <span class="font3" @click="checkReport">举报</span>
      </div> -->
    </div>
    <!-- <div class="boxTwo">
      <el-carousel
        :interval="3000"
        trigger="click"
        ref="slideCarousel"
        arrow="never"
      >
        <el-carousel-item
          v-for="(item, index) in $store.state.banner"
          :key="index"
        >
          <img :src="item.img" class="img" @click="open(item.url)" />
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <template v-if="detail.share_list.length == 1">
      <div
        class="boxThree"
        v-for="(item, index) in detail.share_list"
        :key="index"
      >
        <div class="topBox">
          <div class="imgBox">
            <img :src="item.icon" class="topImg" />
          </div>
          <span class="font4">{{ item.url_title }}</span>
        </div>
        <div
          class="cBoxNo"
          @click="checkRebate($event, item)"
          v-if="item.unlocked_status == 0"
        >
          <img :src="$utils.getPng('icon-short-byeh')" class="noImg" />
          <span class="font5">{{ rebateText }}</span>
        </div>
        <div class="cBoxYes" v-else>
          <span class="font6">{{ item.jump_url }}</span>
          <svg-btn
            @click="copy(item.jump_url)"
            class="copyIcon"
            icon-class="icon-short-copy"
          />
        </div>
        <fm-button
          class="h5Bt"
          type="primary"
          round
          size="medium"
          @click="checkRebate($event, item)"
          :icon="
            item.unlocked_status == 0 ? 'icon-short-two' : 'icon-short-one'
          "
          >{{ item.unlocked_status == 0 ? '解锁' : '打开' }}</fm-button
        >
      </div>
    </template>
    <template v-if="detail.share_list.length > 1">
      <div class="boxFour">
        <div class="titleBox">
          <span class="title">目标网址</span>
          <span class="num">{{ detail.share_list.length }}</span>
        </div>
        <div
          class="arrBox"
          v-for="(item, index) in detail.share_list"
          :key="index"
        >
          <div class="topBox">
            <div class="imgBox">
              <img :src="item.icon" class="topImg" />
            </div>
            <span class="font4">{{ item.url_title }}</span>
          </div>
          <div
            class="cBoxNo"
            @click="checkRebate($event, item)"
            v-if="item.unlocked_status == 0"
          >
            <img :src="$utils.getPng('icon-short-byehNew')" class="noImg" />
            <span class="font5">{{ rebateText }}</span>
          </div>
          <div class="cBoxYes" v-else>
            <span class="font6">{{ item.jump_url }}</span>
            <svg-btn
              @click="copy(item.jump_url)"
              class="copyIcon"
              icon-class="icon-short-copy"
            />
          </div>
          <fm-button
            type="primary"
            round
            size="medium"
            class="h5Bt"
            :icon="
              item.unlocked_status == 0 ? 'icon-short-two' : 'icon-short-one'
            "
            @click="checkRebate($event, item)"
            >{{ item.unlocked_status == 0 ? '解锁' : '打开' }}</fm-button
          >
        </div>
      </div>
    </template>
    <wxLink
      :isShow="wxLinkShow"
      :content="linkTitle"
      @submit="submit"
      @handleClose="wxLinkShow = false"
    />
    <!-- 举报 -->
    <reportDialog
      ref="reportRef"
      type="h5"
      :isShow="showReport"
      :fshort="detail.fshort"
      @handleClose="showReport = false"
    ></reportDialog>
    <!-- 取消收藏提示框 -->
    <TitleDialog
      :is-show="collectShow"
      text="确定取消收藏该短链吗？"
      @handleClose="onCollectClose"
      @handleConfirm="onCollectConfirm"
    >
    </TitleDialog>
    <!-- 回到顶部按钮 -->
    <div v-show="isShowBackTop" @click="scrollToTop" class="backTop">
      <svg-btn icon-class="icon-short-backTop-h5" class="img"></svg-btn>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'
import wxLink from '@/components/Dialog/wxLink.vue'
import reportDialog from '@/components/Dialog/reportDialog'
import TitleDialog from '@/components/Dialog/TitleDialog.vue'
import {
  getJumpUrlAPI,
  getAppletSchemeAPI,
  checkUnlock,
  addShortColl,
  delShortColl,
} from '@/axios/home'
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      wxLinkShow: false,
      showReport: false,
      linkType: '', //3是小程序 4是APP
      linkTitle: '链接需前往 Feemoo APP看视频获取',
      phonedata: common.getPhone(),
      wxUrl: '',
      sc: '', //屏幕点击位置
      ms: '', //屏幕点击位置
      isShowBackTop: false, // 控制按钮显示/隐藏
      scrollContainer: null, // 滚动容器DOM引用
      collectShow: false, //取消收藏弹窗是否显示
      zcFshort:'',//暂存fshort
    }
  },
  components: {
    wxLink,
    reportDialog,
    TitleDialog,
  },
  computed: {
    rebateText() {
      const { rebate_model } = this.detail
      const { isLogin } = this.$store.state

      const textMap = {
        2: isLogin ? '点击解锁获取链接' : '登录后点击解锁',
        3: isLogin ? '去小程序看广告解锁' : '登录后去小程序看广告解锁',
        4: isLogin ? '去APP看广告解锁' : '登录后去APP看广告解锁',
      }

      return textMap[rebate_model] || '登录后点击解锁'
    },
  },
  mounted() {
    this.scrollContainer = this.$refs.scrollContainer
    this.scrollContainer.addEventListener('scroll', this.handleScroll)
    document.addEventListener('visibilitychange', this.handleVisiable)
    //调用方法
    // this.slideBanner()
  },
  destroyed() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.handleScroll)
    }
    document.removeEventListener('visibilitychange', this.handleVisiable)
  },
  methods: {
    checkCollect: _.debounce(
      async function () {
        let isLogin = localStorage.getItem('shortLogin')
        if (isLogin != 1) {
          this.toLogin()
          return
        } 
        if (this.detail.is_collect == 1) {
          this.collectShow = true
          return
        }
        addShortColl({
          short_url: this.detail.fshort,
        }).then(res => {
          if (res.status == 1) {
            this.detail.is_collect = 1
          }
          this.$htoast(res.msg)
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //确定取消收藏弹窗
    onCollectConfirm: _.debounce(
      async function () {
        delShortColl({
          short_url: this.detail.fshort,
        }).then(res => {
          if (res.status == 1) {
            this.onCollectClose()
            this.detail.is_collect = 0
          } else {
            this.$htoast(res.msg)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //关闭取消收藏弹窗
    onCollectClose() {
      this.collectShow = false
    },
    open(url) {
      window.open(url, '_href')
    },
    copy(url) {
      this.$copyText(url).then(
        () => {
          this.$htoast('复制链接成功')
        },
        () => {
          this.$htoast('复制链接失败')
        }
      )
    },
    //获取微信跳转链接
    getAppletScheme() {
      getAppletSchemeAPI({ fshort: this.zcFshort }).then(res => {
        if (res.status == 1) {
          this.wxUrl = res.data.url
          window.location.href = this.wxUrl
        }
      })
    },
    // 点击跳转链接
    checkRebate: _.debounce(
      async function (e, row) {
        // 1-免登录无条件跳转 2-登录后无条件跳转 3-去小程序看广告后跳转 4-去APP看广告后跳转
        try {
          //已经解锁了的就直接跳转
          if (row.unlocked_status == 1) {
            window.open(row.jump_url, '_href')
            return
          }
          e = e || window.event
          this.ms = e.clientX + '*' + e.clientY
          this.sc = window.screen.width + '*' + window.screen.height
          let data = {
            ms: this.ms,
            sc: this.sc,
            fshort: row.fshort,
          }
          let res = await getJumpUrlAPI(data)
          if (res.status == 1) {
            //这是为了解决多标签页下同一个短链状态不同步的处理方式
            let num = Number(res.data.rebate_model)
            if((num === 3 || num === 4) && Number(res.data.require_token) === 0){
              row.jump_url = res.data.jump_url
              row.unlocked_status = 1
              window.open(row.jump_url, '_href')
              return
            }
            switch (num) {
              case 1:
              case 2:
                //1-免登录无条件跳转 2-登录后无条件跳转(会先走到10020)
                row.jump_url = res.data.jump_url
                row.unlocked_status = 1
                break
              case 3:
              case 4:
                // 3-去小程序看广告后跳转 4-去APP看广告后跳转
                this.zcFshort = row.fshort
                this.linkType = num
                this.linkTitle =
                  num === 3
                    ? '链接需前往微信Feemoo小程序看视频获取'
                    : '链接需前往 Feemoo APP看视频获取'
                this.wxLinkShow = true
                break
            }
            if (res.data.toast != '') {
              this.$htoast(res.data.toast)
            }
          } else if (res.status == 83001) {
            //短链的状态变更
            this.updataAll()
          } else if (res.status == 10020) {
            //请先登录
            this.toLogin()
            return
          }
          this.codeObj = {}
        } catch (err) {
          // console.log('err', err)
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    checkReport() {
      let isLogin = localStorage.getItem('shortLogin')
      if (isLogin && isLogin == 1) {
        this.showReport = true
      } else {
        this.toLogin()
      }
    },
    toLogin() {
      this.$store.commit('setShowLoginShort', '/login')
      this.$store.commit('setShowLogin', true)
    },
    submit: _.debounce(
      function () {
        if (this.linkType == 3) {
          this.getAppletScheme()
        } else if (this.linkType == 4) {
          this.goApp()
        }
        this.wxLinkShow = false
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //打开APP
    goApp() {
      const timeout = this.phonedata.is_android ? 3000 : 3000
      common.checkOpen(() => {
        if (this.phonedata.is_android) {
          window.location.href = common.apkstore
        } else {
          window.location.href = common.appstore
        }
      }, timeout)
      if (this.phonedata.third_party_browser || this.phonedata.is_baiduboxapp) {
        // 通过第三方app跳转至浏览器打开
        location.href = this.$glb.feemooUrl + '/wap.html'
      } else {
        // 直接在浏览器打开
        common.clickOpen(
          this.phonedata,
          { type: '13' },
          {
            code: this.zcFshort,
            encode_code: this.detail.encode_code,
          }
        )
      }
    },
    //打开微信小程序
    goWx() {
      location.href = this.wxUrl
    },
    // 滑动切换
    slideBanner() {
      //选中的轮播图
      var box = document.querySelector('.el-carousel__container')
      var startPoint = 0
      var stopPoint = 0
      //重置坐标
      var resetPoint = function () {
        startPoint = 0
        stopPoint = 0
      }
      //手指按下
      box.addEventListener('touchstart', function (e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX
      })
      //手指滑动
      box.addEventListener('touchmove', function (e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX
      })
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this
      box.addEventListener('touchend', function (e) {
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint()
          return
        }
        if (startPoint - stopPoint > 0) {
          resetPoint()
          that.$refs.slideCarousel.next()
          return
        }
        if (startPoint - stopPoint < 0) {
          resetPoint()
          that.$refs.slideCarousel.prev()
          return
        }
      })
    },
    //重置状态
    updataAll() {
      this.zcFshort = ''
      this.showReport = false
      this.wxLinkShow = false
      this.$store.commit('setShowLoginShort', '')
      this.$store.commit('setShowLogin', false)
      this.$store.commit('getShortDetail')
    },
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        case 'visible':
          //满足条件，1 登录  2当前页面是未解锁状态 3后端告诉前端当前短链是否解锁
          let isLogin = localStorage.getItem('shortLogin')
          if (isLogin && isLogin == 1 && this.detail.unlocked_status == 0) {
            // const fshortList = this.detail.share_list.filter(item => item.unlocked_status == 0).map(item => item.fshort).join(',')
            const shareList = this.detail?.share_list || [];
            const unlockedItems = shareList.filter(item => item.unlocked_status == 0);
            const fshortValues = unlockedItems.map(item => item.fshort);
            const fshortList = fshortValues.join(',');
            checkUnlock({
              ver:2,
              fshort: fshortList,
            }).then(res => {
              if (res.status == 1 && res.data.unlockedStatus == 1) {
                  this.updataAll()
              }
            })
          }
          break
      }
    },
    // 判断是否显示回到顶部按钮
    handleScroll() {
      const scrollTop = this.scrollContainer.scrollTop + 64
      const containerHeight = this.scrollContainer.clientHeight
      this.isShowBackTop = scrollTop > 72
    },

    // 回到顶部逻辑
    scrollToTop() {
      this.scrollContainer.scrollTo({
        top: 0,
        behavior: 'smooth', // 平滑滚动
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.BoxContent {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  width: 100%;
  height: 100%;
  .boxOne {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 32px;
    width: 100%;
    padding: 20px;
    height: 88px;
    margin-bottom: 16px;
    .leftLogo {
      width: 32px;
      height: 32px;
      object-fit: cover;
      border-radius: 50%;
    }
    .rightBox {
      margin-left: 12px;
      display: flex;
      flex-direction: column;
      flex: 1;
      .one {
        display: flex;
        align-items: center;
        margin-bottom: 3px;
        .collect {
          margin-left: 4px;
          width: 18px;
          height: 18px;
          cursor: pointer;
          color: #bdbdbe;
        }
      }
      .font1 {
        font-weight: 500;
        font-size: 12px;
        color: #2c2c2c;
        line-height: 16px;
        @include multiline(1);
      }
      .topBox {
        display: flex;
        align-items: center;
        width: 100%;
        .two {
          flex: 1;
          .font2 {
            font-weight: 400;
            font-size: 10px;
            color: #8a8b92;
            line-height: 14px;
            @include multiline(1);
          }
        }
        .font3 {
          font-weight: 400;
          font-size: 10px;
          color: #f67942;
          line-height: 14px;
          margin-left: 20px;
          cursor: pointer;
        }
      }
    }
  }
  .boxTwo {
    width: 100%;
    height: 188px;
    background: #ffffff;
    border-radius: 32px;
    ::v-deep .el-carousel {
      height: 100%;
      border-radius: 32px;
      .el-carousel__container {
        height: 100% !important;
      }
      .el-carousel__indicator {
        padding: 0;
        margin-right: 4px;
        margin-bottom: 10px;
      }
      .is-active {
        .el-carousel__button {
          opacity: 1 !important;
          width: 8px !important;
        }
      }
      .el-carousel__button {
        width: 3px;
        height: 3px;
        background: #ffffff;
        border-radius: 1.5px;
        opacity: 0.4;
      }
    }
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 32px;
    }
  }
  .boxThree {
    width: 100%;
    height: 226px;
    background: #ffffff;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 26px 20px 28px 20px;
    .topBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 40px;
      margin-bottom: 18px;
      .imgBox {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 0.5px solid #e5e5e5;
          .topImg {
            width: 20px;
            height: 20px;
            object-fit: cover;
            border-radius: 6px;
          }
        }
      .font4 {
        font-weight: 500;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        margin-left: 12px;
        // max-width: 247px;
        flex: 1;
        @include multiline(2);
      }
    }
    .cBoxNo {
      position: relative;
      margin-bottom: 18px;
      width: 100%;
      height: 48px;
      cursor: pointer;
      .noImg {
        width: 100%;
        height: 48px;
      }
      .font5 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        max-width: 100%;
        text-align: center;
        padding: 0 12px;
        @include multiline(1);
      }
    }
    .cBoxYes {
      width: 100%;
      margin-bottom: 18px;
      background: #f6f6f6;
      border-radius: 25px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 0 52px;
      // padding-right: 20px;
      .font6 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        max-width: 100%;
        text-align: center;
        @include multiline(1);
      }
      .copyIcon {
        width: 20px;
        height: 20px;
        cursor: pointer;
        position: absolute;
        right: 20px;
      }
    }
    ::v-deep .h5Bt {
      width: 100%;
      height: 48px;
      border-radius: 24px;
      .svg-icon {
        width: 22px;
        height: 22px;
      }
      span {
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
        margin-left: 4px;
        margin-right: 0;
        margin-top: 2px;
      }
    }
  }
  .boxFour {
    width: 100%;
    background: #ffffff;
    border-radius: 32px;
    padding: 20px 20px 26px 20px;
    .titleBox {
      display: flex;
      align-items: center;
      margin-bottom: 26px;
      .title {
        font-weight: 500;
        font-size: 13px;
        color: #2c2c2c;
        line-height: 16px;
        margin-right: 6px;
        flex-shrink: 0;
      }
      .num {
        font-weight: 500;
        font-size: 12px;
        color: #8a8b92;
        line-height: 16px;
        @include multiline(1);
      }
    }
    .arrBox {
      margin-bottom: 26px;
      padding-bottom: 26px;
      flex-direction: column;
      box-shadow: inset 0px -0.5px 0px 0px #e5e5e5;
      display: flex;
      align-items: center;
      &:last-child {
        box-shadow: none !important;
        margin-bottom: 0 !important;
        padding-bottom: 0 !important;
      }
      .topBox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-bottom: 18px;
        .imgBox {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 0.5px solid #e5e5e5;
          .topImg {
            width: 20px;
            height: 20px;
            object-fit: cover;
            border-radius: 6px;
          }
        }
        .font4 {
          font-weight: 500;
          font-size: 14px;
          color: #2c2c2c;
          line-height: 20px;
          margin-left: 12px;
          flex: 1;
          @include multiline(2);
        }
      }
      .cBoxNo {
        position: relative;
        margin-bottom: 18px;
        width: 100%;
        height: 48px;
        cursor: pointer;
        .noImg {
          width: 100%;
          height: 48px;
        }
        .font5 {
          font-weight: 400;
          font-size: 14px;
          color: #2c2c2c;
          line-height: 20px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          max-width: 100%;
          text-align: center;
          padding: 0 12px;
          @include multiline(1);
        }
      }
      .cBoxYes {
        width: 100%;
        margin-bottom: 18px;
        background: #f6f6f6;
        border-radius: 25px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding: 0 52px;
        // padding-right: 20px;
        .font6 {
          font-weight: 400;
          font-size: 14px;
          color: #2c2c2c;
          line-height: 20px;
          max-width: 100%;
          text-align: center;
          @include multiline(1);
        }
        .copyIcon {
          width: 20px;
          height: 20px;
          cursor: pointer;
          position: absolute;
          right: 20px;
        }
      }
      ::v-deep .h5Bt {
        width: 100%;
        height: 48px;
        border-radius: 24px;
        .svg-icon {
          width: 22px;
          height: 22px;
        }
        span {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
          margin-left: 4px;
          margin-right: 0;
          margin-top: 2px;
        }
      }
    }
  }
}
.BoxMore {
  overflow: auto;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 36px;
  -webkit-overflow-scrolling: touch;
}
.BoxMore::-webkit-scrollbar {
  display: block;
}
.backTop {
  position: fixed;
  bottom: 50px;
  right: 20px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #f6f6f6;
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  .img {
    width: 24px;
    height: 24px;
  }
}
</style>
